import { createStore, applyMiddleware } from 'redux';
import { thunk } from "redux-thunk";

const persistedAvatar = (() => {
    try { return localStorage.getItem('avatar') || null; } catch (e) { return null; }
})();

const initialState = {
    starCount: 0,
    avatar: persistedAvatar || 'orangecat',
};

const starReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'INCREMENT_STAR':
            return {
                ...state,
                starCount: state.starCount + action.payload
            };
        case "SET_STAR_COUNT":
            return { ...state, 
                starCount: action.payload };
        case "SET_AVATAR":
            return { ...state, 
                avatar: action.payload };
        default:
            return state;
    }
};

const store = createStore(starReducer, applyMiddleware(thunk));

export default store;